import React from "react";
import { connect } from "react-redux";
import styled, { withTheme } from "styled-components";
import { t } from "../../../core/translate";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import { selectors as routerSelectors } from "../../../../redux/router";
import { Button } from "@vitalsource/vstui";
import DefaultSearchContainer from "./search-container/default-search-container";

const StyledNullScreen = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  ${styledMedia.small`
		padding: 0 45px;
  `}
`;

const HeadingBlockParagraph = styled.p`
  display: flex;
  justify-content: center;
  font-size: 1.6rem;
  font-weight: 500;
  padding: 35px 0 0px 0;
  width: 100%;
`;

const LibraryNullSearchScreen = ({ search }) => {
  return (
    <StyledNullScreen>
      <HeadingBlockParagraph>
        <DefaultSearchContainer />
      </HeadingBlockParagraph>
      <HeadingBlockParagraph />
      <Button href={`/#/${search}`}>
        {t("explorer.empty-button", "Go to My Library")}
      </Button>
    </StyledNullScreen>
  );
};

const mapStateToProps = state => ({
  search: routerSelectors.getSearch(state)
});

export default withTheme(connect(mapStateToProps)(LibraryNullSearchScreen));
